import {createSlice} from "@reduxjs/toolkit";
import {setChatPageChannelUrl} from "./actions";

type State = {
  channelUrl?: string
}

const INITIAL_STATE: Readonly<State> = {
  channelUrl: undefined,
};

const chatPageSlice = createSlice({
  name: "ots-ui/chat-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setChatPageChannelUrl,
      (state, {payload}) => {
        state.channelUrl = payload
      }
    );
  }
});

export const chatPageReducer = chatPageSlice.reducer;
